import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Col, Button } from "react-bootstrap";

import "react-toastify/dist/ReactToastify.css";
import "react-activity/dist/library.css";
import { loader } from "../../../loader";
import { toast } from "react-toastify";
import { getData, postData } from "../../../axios/apiInstanceHelper";
import { ENDPOINT } from "../../../axios/apiConfig";

const PreviewHighlight = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [selectedElement, setSelectedElement] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async () => {
    try {
      loader("show");
      setIsSubmitting(true);
      const {
        element,
        image,
        attach_content,
        selectedContent,
        heading,
        sub_heading,
        content,
      } = state;

      const data = await postData(
        ENDPOINT.CREATE_UPDATE_HIGHLIGHT + (element?.id ? `/${element?.id}` : ""),
        {
          ...element,
          image: image,
          attach_content: attach_content,
          content_id: attach_content && selectedContent && selectedContent?.id,
          heading: heading,
          sub_heading: sub_heading,
          content: content,
          section_type: 1,
          highlightType: 1,
        },
        {
          headers: {
            Token: localStorage.getItem("user_id"),
            frontendid: localStorage.getItem("user_id"),
            created_by: localStorage.getItem("user_id"),
          },
        },
      );
      if ([200, 201].includes(data?.status)) {
        navigate("/highlights");
      }
    } catch (err) {
      console.log("error while creating or update the highlight : ", err);
      toast.error(
        state?.type === "edit"
          ? "Failed to update the highlight"
          : "Failed to create the hightlight",
      );
    } finally {
      setIsSubmitting(false);
      loader("hide");
    }
  };

  useEffect(() => {
    const fetchPrefilledData = async (id) => {
      try {
        loader("show");
        const data = await getData(
          ENDPOINT.GET_HIGHLIGHTS + "/" + id,
          {
            headers: {
              Auth: localStorage.getItem("decrypted_token"),
              frontendid: localStorage.getItem("user_id"),
              Token: localStorage.getItem("user_id"),
              created_by: localStorage.getItem("user_id"),
            },
          },
        );
        if (data?.status === 200) setSelectedElement(data?.data?.data);
      } catch (err) {
        console.log("error while library data : ", err);
        toast.error("Failed to get the attachable contents list");
      } finally {
        loader("hide");
      }
    };
    if (state?.type === "view" && !selectedElement)
      fetchPrefilledData(state?.element?.id);
  }, [state]);

  const handleBack = () => {
    navigate("/create-edit-highlight", {
      state: {
        ...state,
        type: "edit",
        id: state?.element?.id,
        element: state?.element,
      },
    });
  };

  return (
    <Col className="right-sidebar custom-change onesource-opition">
      <div className="custom-container">
        <>
          <div className="page-top-nav sticky">
            <div className="d-flex justify-content-between align-items-center w-100">
              {state?.type === "view" && (
                <Col className="col-auto">
                  <div className="page-title d-flex">
                    <a
                      className="back-btn"
                      href="/highlights"
                      data-discover="true"
                    >
                      <svg
                        width="14"
                        height="24"
                        viewBox="0 0 14 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {" "}
                        <path
                          d="M0.159662 12.0019C0.159662 11.5718 0.323895 11.1417 0.65167 10.8138L10.9712 0.494292C11.6277 -0.16216 12.692 -0.16216 13.3482 0.494292C14.0044 1.15048 14.0044 2.21459 13.3482 2.8711L4.21687 12.0019L13.3479 21.1327C14.0041 21.7892 14.0041 22.8532 13.3479 23.5093C12.6917 24.1661 11.6274 24.1661 10.9709 23.5093L0.65135 13.19C0.323523 12.8619 0.159662 12.4319 0.159662 12.0019Z"
                          fill="#97B6CF"
                        ></path>{" "}
                      </svg>
                    </a>
                   < h2>
                    {"Highlights"}
                  </h2>
                  </div>
                </Col>
              )}
              {state?.type !== "view" && (
                <>
                  <Col>
                    <Button
                      className="btn btn-primary btn-bordered move-draft"
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                  </Col>
                  <Col md={9}>
                    <ul className="tabnav-link">
                      <li className="">
                        <a href="#">
                          {state?.type === "edit"
                            ? "Update your highlight"
                            : "Create your highlight"}
                        </a>
                      </li>
                      <li className="active active-main">
                        <a href="#">Preview your highlight</a>
                      </li>
                    </ul>
                  </Col>
                  <Col md={2}>
                    <div className="header-btn">
                      <Button
                        className="btn btn-primary btn-bordered move-draft"
                        onClick={() => navigate("/highlights")}
                      >
                        Cancel
                      </Button>

                      <button
                        type="submit"
                        className={"btn btn-primary send_btn"}
                        disabled={isSubmitting}
                        onClick={handleSubmit}
                      >
                        {isSubmitting
                          ? "Processing..."
                          : state?.type === "edit"
                            ? "Update"
                            : "Create"}
                      </button>
                    </div>
                  </Col>
                </>
              )}

              {state?.type === "view" && (
                <Col className="col-auto">
                  <button type="button" className="btn-white btn btn-primary" onClick={handleBack}>
                    Edit Highlight
                    <img
                      src="https://informed.pro/componentAssets/images/edit-button.svg"
                      alt=""
                    />
                  </button>
                </Col>
              )}
            </div>
          </div>
          <div className="preview-content">
            <div className="preview-content-inset rd_view">
              <div className="trigger_content_image">
                <img
                  src={state?.image || selectedElement?.image}
                  alt="Preview"
                />
              </div>

              <div className="trigger_content">
                <h5>{state?.heading || selectedElement?.heading || "N/A"}</h5>
                <h6>
                  {state?.sub_heading || selectedElement?.sub_heading || "N/A"}
                </h6>
              </div>

              <div className="trigger_content_description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: state?.content || selectedElement?.content || "N/A",
                  }}
                />
              </div>
            </div>
            {(state?.selectedContent || selectedElement?.pdf) && (
              <div className="preview-content-inset rd_view">
                <div className="symposium-highlight-videos">
                  <h4>Content</h4>
                  <div className="mail_trigger_content d-flex">
                    <div className="trigger_content_image">
                      <img
                        src={
                          "https://docintel.s3-eu-west-1.amazonaws.com/cover/OctapharmaTrials/" +
                          (state?.selectedContent?.pdf_file ||
                            selectedElement?.pdf?.thumbs)
                        }
                        alt="Preview"
                      />
                    </div>
                    <div className="trigger_content d-flex flex-column">
                      <h6 className="title">
                        {state?.selectedContent?.title ||
                          selectedElement?.pdf?.title ||
                          "N/A"}
                      </h6>
                      <h6 className="sub-title">
                        {state?.selectedContent?.pdf_sub_title ||
                          selectedElement?.pdf?.pdf_sub_title ||
                          "N/A"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      </div>
    </Col>
  );
};

export default PreviewHighlight;
